import React from 'react';
import formatDateTime from 'src/utils/formatDateTime';
import Text from 'src/components/Text';

type Props = {
  merchant: any;
  tokenEmissionTimestamp?: any; // это поле вынесено отдельно, чтобы снаружи можно было управлять отображением этого поля. Проблемным является кейс, когда токен перевыпускается. На момент открытия первой модалки с подтверждением у записи уже есть это значение (timestamp старого токена). После отзыва старого токена и выпуска нового одновременно будет и открываться вторая модалка и инвалидироваться кэш списка ТСП. Пока новый список не придёт в этом поле будет timestamp старого токена. Проблемы не было бы, если бы бэк в ответ на эмиссию токена присылал бы и токен и timestamp, но бэк присылает только токен.
};

const MerchantInfo: React.FC<Props> = ({ merchant, tokenEmissionTimestamp }) => {
  if (!merchant) {
    return null;
  }

  return (
    <>
      <Text type="p" muted>Merchant ID: {merchant?.merchantId}</Text>
      <Text type="p" muted>Название ТСП: {merchant?.brandName}</Text>
      <Text type="p" muted>Адрес: {merchant?.address}</Text>
      <Text type="p" muted>Дата регистрации ТСП: {formatDateTime(merchant?.registrationDate, 'DD.MM.YYYY')}</Text>
      {tokenEmissionTimestamp && (
        <Text type="p" muted>
          Дата и время получения токена:{' '}
          {formatDateTime(merchant?.tokenEmissionTimestamp, 'DD.MM.YYYY HH:mm')}
        </Text>
      )}
    </>
  );
};

export default MerchantInfo;
